export default __webpack_public_path__ + "faa7d57f39cc39cea2bca2ed75bb029e.png";